/* eslint no-useless-escape: 0 */

const sj = "Audio samples taken from \"Welcome to Southern California (1953)\""

export default sj;